/* DRT custom wishlist — localStorage based, no app required.
   - Hearts on cards + product page toggle items in/out of the list
   - Header badge shows the saved count
   - The /pages/wishlist page renders saved items and lets you add to cart
   All data lives in the browser (per-device). Namespaced under window.DRTWishlist. */
(function () {
  'use strict';

  var STORAGE_KEY = 'drt_wishlist_v1';

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* storage full / disabled — fail silently */
    }
    document.dispatchEvent(new CustomEvent('drt:wishlist:change', { detail: { items: items } }));
  }

  function has(id) {
    id = String(id);
    return read().some(function (it) {
      return String(it.id) === id;
    });
  }

  function itemFromButton(btn) {
    return {
      id: btn.getAttribute('data-drt-wishlist-id'),
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      url: btn.getAttribute('data-product-url'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price'),
      variantId: btn.getAttribute('data-variant-id'),
      addedAt: Date.now()
    };
  }

  function toggle(item) {
    var items = read();
    var id = String(item.id);
    var idx = items.findIndex(function (it) {
      return String(it.id) === id;
    });
    var added;
    if (idx > -1) {
      items.splice(idx, 1);
      added = false;
    } else {
      items.unshift(item);
      added = true;
    }
    write(items);
    return added;
  }

  function remove(id) {
    id = String(id);
    write(
      read().filter(function (it) {
        return String(it.id) !== id;
      })
    );
  }

  /* ---- UI sync ---- */

  function syncButtons() {
    var saved = read();
    var savedIds = {};
    saved.forEach(function (it) {
      savedIds[String(it.id)] = true;
    });
    document.querySelectorAll('[data-drt-wishlist-toggle]').forEach(function (btn) {
      var on = !!savedIds[String(btn.getAttribute('data-drt-wishlist-id'))];
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('.drt-wishlist-btn__label');
      if (label) label.textContent = on ? 'In Wishlist' : 'Add to Wishlist';
    });
  }

  function syncBadge() {
    var count = read().length;
    document.querySelectorAll('[data-drt-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.toggleAttribute('hidden', count === 0);
    });
  }

  function syncAll() {
    syncButtons();
    syncBadge();
  }

  /* ---- Wishlist page ---- */

  function addToCart(variantId, btn) {
    if (!variantId) return;
    if (btn) {
      btn.disabled = true;
      btn.dataset.label = btn.textContent;
      btn.textContent = 'Adding…';
    }
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function () {
        window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
      })
      .catch(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = btn.dataset.label || 'Add to cart';
        }
        alert('Sorry, that could not be added to your cart.');
      });
  }

  function renderPage() {
    var root = document.getElementById('drt-wishlist-root');
    if (!root) return;
    var items = read();

    if (!items.length) {
      var emptyHref = root.getAttribute('data-empty-url') || '/collections/all';
      root.innerHTML =
        '<div class="drt-wishlist-empty">' +
        '<svg viewBox="0 0 24 24" width="48" height="48" aria-hidden="true"><path d="M12 21s-7.5-4.6-10-9.2C.3 8.3 1.9 5 5.2 5c2 0 3.4 1.1 4.3 2.3.4.5.6.8.5.8s.1-.3.5-.8C11.4 6.1 12.8 5 14.8 5c3.3 0 4.9 3.3 3.2 6.8C19.5 16.4 12 21 12 21z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>' +
        '<p>Your wishlist is empty.</p>' +
        '<a class="drt-wishlist-empty__cta button" href="' +
        emptyHref +
        '">Browse packs</a>' +
        '</div>';
      return;
    }

    var html = '<div class="drt-wishlist-grid">';
    items.forEach(function (it) {
      var img = it.image
        ? '<img src="' + it.image + '" alt="' + escapeHtml(it.title) + '" loading="lazy" width="400" height="400">'
        : '';
      html +=
        '<div class="drt-wishlist-card" data-id="' +
        escapeHtml(it.id) +
        '">' +
        '<button type="button" class="drt-wishlist-card__remove" data-drt-wishlist-remove="' +
        escapeHtml(it.id) +
        '" aria-label="Remove from wishlist" title="Remove">&times;</button>' +
        '<a class="drt-wishlist-card__media" href="' +
        escapeHtml(it.url) +
        '">' +
        img +
        '</a>' +
        '<div class="drt-wishlist-card__body">' +
        '<a class="drt-wishlist-card__title" href="' +
        escapeHtml(it.url) +
        '">' +
        escapeHtml(it.title) +
        '</a>' +
        (it.price ? '<div class="drt-wishlist-card__price">' + escapeHtml(it.price) + '</div>' : '') +
        '<div class="drt-wishlist-card__actions">' +
        (it.variantId
          ? '<button type="button" class="button drt-wishlist-card__atc" data-drt-wishlist-atc="' +
            escapeHtml(it.variantId) +
            '">Add to cart</button>'
          : '<a class="button drt-wishlist-card__atc" href="' + escapeHtml(it.url) + '">View</a>') +
        '</div>' +
        '</div>' +
        '</div>';
    });
    html += '</div>';
    root.innerHTML = html;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ---- Events (delegated, so it works for cards added after load) ---- */

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-drt-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      toggle(itemFromButton(toggleBtn));
      return;
    }
    var removeBtn = e.target.closest('[data-drt-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      var card = removeBtn.closest('.drt-wishlist-card');
      remove(removeBtn.getAttribute('data-drt-wishlist-remove'));
      if (card) card.remove();
      if (!read().length) renderPage();
      return;
    }
    var atcBtn = e.target.closest('[data-drt-wishlist-atc]');
    if (atcBtn) {
      e.preventDefault();
      addToCart(atcBtn.getAttribute('data-drt-wishlist-atc'), atcBtn);
    }
  });

  document.addEventListener('drt:wishlist:change', function () {
    syncButtons();
    syncBadge();
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncAll();
    renderPage();
  });
  // In case the script loads after DOMContentLoaded already fired:
  if (document.readyState !== 'loading') {
    syncAll();
    renderPage();
  }

  window.DRTWishlist = { read: read, has: has, toggle: toggle, remove: remove, refresh: syncAll };
})();
